import { action, computed, thunk } from 'easy-peasy'

import { FetchStatus } from '@/types'

import { HistoryModel, service } from '.'
import { AxiosError } from 'axios'

export const history: HistoryModel = {
	data: [],
	status: FetchStatus.IDLE,
	paginator: {
		current_page: 1,
		next_page: 0,
		per_page: 10,
		previous_page: 0,
		total_items: 0,
		total_pages: 1
	},
	error: '',
	detail: null,
	detailStatus: FetchStatus.IDLE,
	detailError: '',

	/** Computed */
	loading: computed(state => state.status === FetchStatus.LOADING),
	loadingMore: computed(state => state.status === FetchStatus.FETCHING_MORE),
	loaded: computed(state => state.status === FetchStatus.LOADED),
	detailLoading: computed(state => state.detailStatus === FetchStatus.LOADING),

	/** Action */
	setData: action((state, payload) => {
		state.data = payload
	}),
	addData: action((state, payload) => {
		state.data = [...state.data, ...payload]
	}),
	setPaginator: action((state, payload) => {
		state.paginator = payload
	}),
	setStatus: action((state, payload) => {
		state.status = payload
	}),
	setError: action((state, payload) => {
		state.error = payload
	}),
	setDetail: action((state, payload) => {
		state.detail = payload
	}),
	setDetailStatus: action((state, payload) => {
		state.detailStatus = payload
	}),
	setDetailError: action((state, payload) => {
		state.detailError = payload
	}),

	/** Thunks */
	fetch: thunk(async (action, payload) => {
		try {
			action.setStatus(FetchStatus.LOADING)
			const res = await service.fetch(payload)
			action.setData(res.data)
			action.setPaginator(res.paginator)
			action.setStatus(FetchStatus.LOADED)
		} catch (e) {
			if (e instanceof AxiosError) {
				action.setStatus(FetchStatus.ERROR)
				action.setError(
					e?.response?.data?.message ||
						(navigator.onLine ? 'Server Error' : 'Network Error')
				)
			}
		} finally {
			setTimeout(() => {
				action.setError('')
			}, 1)
		}
	}),
	fetchMore: thunk(async (action, payload) => {
		try {
			action.setStatus(FetchStatus.FETCHING_MORE)
			const res = await service.fetch(payload)
			action.addData(res.data)
			action.setPaginator(res.paginator)
			action.setStatus(FetchStatus.LOADED)
			action.setError('')
		} catch (e) {
			if (e instanceof AxiosError) {
				action.setStatus(FetchStatus.ERROR)
				action.setError(
					e?.response?.data?.message ||
						(navigator.onLine ? 'Server Error' : 'Network Error')
				)
			}
		} finally {
			setTimeout(() => {
				action.setError('')
			}, 1)
		}
	}),
	fetchDetail: thunk(async (action, payload) => {
		try {
			action.setDetailStatus(FetchStatus.LOADING)
			action.setDetailError('')
			const res = await service.fetchDetail(payload)
			action.setDetail(res.data)
			action.setDetailStatus(FetchStatus.LOADED)
		} catch (e) {
			if (e instanceof AxiosError) {
				action.setDetailStatus(FetchStatus.ERROR)
				action.setDetailError(
					e?.response?.data?.message ||
						(navigator.onLine ? 'Server Error' : 'Network Error')
				)
			}
		} finally {
			setTimeout(() => {
				action.setDetailError('')
			}, 1)
		}
	})
}
